<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title">
        <span class="fonints">时间选择</span>
        <el-date-picker
          v-model="year"
           type="date"
          value-format="yyyy-MM-dd"
          placeholder="请选择年月日"
        >
        </el-date-picker>
        <button class="buttons" @click="selectinfo">查询</button>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import { antiShake } from "@/plugins/other.js";
export default {
  data() {
    return {
      listitem: [{ name: "统计分析" }, { name: "进港统计" }],
      year: "", //年
      radio: "0",
      radio2: "0",
      tabledata: [],
    };
  },
  components: {
    mTitle,
  },
  methods: {
     async getTableMsg() {
       const { data } = await this.$http("api1", "/statistics/carsuttlenumber/synchronizationCarSuttleNumber", "get", {
        yearMonthDataString: this.year,
      });
      console.log(data)
    },
    selectinfo() {
      antiShake((_) => {
        this.getTableMsg();
      });
    },
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>
